// extracted by mini-css-extract-plugin
export default {"wrapper":"CartItem_wrapper__ez8s+","detail":"CartItem_detail__ijS+f","image":"CartItem_image__oL2A6","buttons":"CartItem_buttons__mGNR2","price":"CartItem_price__pP54w"};